import React from 'react';

export interface TabProps {
  label: string;
  link?: string;
  isActive?: boolean;
  icon?: string;
  onClick?: () => void;
  fontSize?: 14 | 16;
  hasDividerOnRight?: boolean;
}

const Tab: React.FC<TabProps> = ({
  label,
  link,
  isActive = false,
  icon,
  onClick,
  fontSize,
  hasDividerOnRight = false,
}) => {
  const activeClass = isActive ? ' active' : '';
  const fontSizeClass = fontSize === 14 ? ' basic-14' : ' basic-16';
  const iconClass = icon ? ` tab--${icon}` : '';

  // Combining all class names
  const combinedClass = `tab${activeClass}${fontSizeClass}${iconClass}`;

  return (
    <>
      <li className={combinedClass}>
        <button className={fontSizeClass} onClick={onClick}>
          <span>{label}</span>
        </button>
      </li>
      {hasDividerOnRight && (
        <li className="tab--divider-container">
          <div className="tab--divider" />
        </li>
      )}
    </>
  );
};

export default Tab;
